// Общая палитра эмодзи для markdown-редакторов (посты + комментарии).
// Подборка для рабочего общения; вставляется обычным текстом, в
// отрендеренном виде twemoji отрисует картинками как везде.
export const EMOJI_LIST = [
    "😀", "😁", "😂", "🤣", "😅", "😊", "🙂", "😉", "😍", "🤩", "😎", "🤔",
    "🤨", "😏", "😐", "🙄", "😬", "😴", "🤯", "😱", "😭", "😢", "😤", "🥲",
    "🥳", "🤡", "💀", "🫡", "🤝", "👍", "👎", "👌", "✌️", "🤞", "🙏", "💪",
    "👏", "🔥", "❤️", "💯", "🎉", "🚀", "💡", "⚡", "✅", "❌", "❓", "💰",
];

// Ванильная версия для серверных страниц (редактор постов в App.js), где
// нет Vue. Палитра создаётся лениво при первом клике и живёт внутри
// .EasyMDEContainer редактора; классы .emoji-picker/.emoji-picker-item —
// те же, что у Vue-версии в DesktopMarkdownEditor.vue (стили глобальные,
// извлекаются в общий CSS-бандл).
export function toggleEmojiPicker(editor) {
    const wrapper = editor.codemirror.getWrapperElement().parentElement; // .EasyMDEContainer
    let picker = wrapper.querySelector(".emoji-picker");

    if (picker) {
        picker.style.display = picker.style.display === "none" ? "" : "none";
        return;
    }

    picker = document.createElement("div");
    picker.className = "emoji-picker";
    // не отдавать фокус (и позицию курсора) из CodeMirror при клике по палитре
    picker.addEventListener("mousedown", (e) => e.preventDefault());

    EMOJI_LIST.forEach((emoji) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "emoji-picker-item";
        btn.textContent = emoji;
        btn.addEventListener("click", () => {
            editor.codemirror.replaceSelection(emoji);
            editor.codemirror.focus();
        });
        picker.appendChild(btn);
    });

    wrapper.appendChild(picker);

    // Закрытие по клику вне редактора и по Esc. Compose-страница — обычная
    // серверная, редактор живёт до ухода со страницы, снимать нечего.
    document.addEventListener("click", (e) => {
        if (picker.style.display === "none") return;
        if (wrapper.contains(e.target)) return;
        picker.style.display = "none";
    });
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") picker.style.display = "none";
    });
}
